import React from "react"

export default function Content({children, classes, width})
{       
    const c = classes !== undefined ? ' '+classes : ''
    const w = width !== undefined ? width : 'col-lg-8'
    
    return (
        <div className={'mid '+w}>
            <div className={"content"+c}>{children}</div>    
        </div>       
    ) 
}